// -- AUTOGENERATED --

// eslint-disable-next-line no-unused-vars
import APIUtils from '@/util/apiutil'

import Axios from 'axios'
import NETVSConfig from '@/../netvs.config'

/* eslint-disable camelcase */
/* eslint-disable quote-props */
/* eslint-disable object-curly-spacing */
/* eslint-disable array-bracket-spacing */
/* eslint-disable object-shorthand */
export default {

  createParamsList () {
    return {'old': [ ], 'new': [ 'type', 'fq_name', 'next_gpk', 'prior_gpk', 'pos_to_last', 'pos_to_first', 'ext_orgdata_key', 'is_mgr_assignable']}
  },
  create (config, {type_new, fq_name_new, next_gpk_new, prior_gpk_new, pos_to_last_new, pos_to_first_new, ext_orgdata_key_new, is_mgr_assignable_new = true}) {
    const params = { 'new': { 'type': type_new, 'fq_name': fq_name_new, 'next_gpk': next_gpk_new, 'prior_gpk': prior_gpk_new, 'pos_to_last': pos_to_last_new, 'pos_to_first': pos_to_first_new, 'ext_orgdata_key': ext_orgdata_key_new, 'is_mgr_assignable': is_mgr_assignable_new}, 'old': { }}
    // TODO: Return ta-object instead
    return Axios.post(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/org/unit/create`, params, (config || {}).netdb_axios_config)
  // eslint-disable-next-line comma-dangle
  },
  deleteParamsList () {
    return {'old': [ 'fq_name'], 'new': [ ]}
  },
  delete (config, {fq_name_old}) {
    const params = { 'new': { }, 'old': { 'fq_name': fq_name_old}}
    // TODO: Return ta-object instead
    return Axios.post(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/org/unit/delete`, params, (config || {}).netdb_axios_config)
  // eslint-disable-next-line comma-dangle
  },
  list (config, { type, gpk_list, tree_level, fetch_limit, fetch_offset, fq_name_list, fq_name_regexp, parent_fq_name, ext_orgdata_key, short_name_list, ext_orgdata_layer, is_mgr_assignable, short_name_regexp, filter_params_dict, sorting_params_list, ext_orgdata_sync_state }) {
    const params = APIUtils.denullify_dict({ 'type': type, 'gpk_list': (gpk_list === null) ? null : JSON.stringify(gpk_list), 'tree_level': tree_level, 'fetch_limit': fetch_limit, 'fetch_offset': fetch_offset, 'fq_name_list': (fq_name_list === null) ? null : JSON.stringify(fq_name_list), 'fq_name_regexp': fq_name_regexp, 'parent_fq_name': parent_fq_name, 'ext_orgdata_key': ext_orgdata_key, 'short_name_list': (short_name_list === null) ? null : JSON.stringify(short_name_list), 'ext_orgdata_layer': ext_orgdata_layer, 'is_mgr_assignable': is_mgr_assignable, 'short_name_regexp': short_name_regexp, 'filter_params_dict': filter_params_dict, 'sorting_params_list': (sorting_params_list === null) ? null : JSON.stringify(sorting_params_list), 'ext_orgdata_sync_state': ext_orgdata_sync_state})
    const cnf = {}
    Object.assign(cnf, (config || {}).netdb_axios_config)
    cnf.params = params
    return Axios.get(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/org/unit/list`, cnf)
  // eslint-disable-next-line comma-dangle
  },
  mergeParamsList () {
    return {'old': [ 'fq_name'], 'new': [ 'fq_name', 'pos_to_last', 'pos_to_first']}
  },
  merge (config, {fq_name_old, fq_name_new, pos_to_last_new = true, pos_to_first_new = false}) {
    const params = { 'new': { 'fq_name': fq_name_new, 'pos_to_last': pos_to_last_new, 'pos_to_first': pos_to_first_new}, 'old': { 'fq_name': fq_name_old}}
    // TODO: Return ta-object instead
    return Axios.post(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/org/unit/merge`, params, (config || {}).netdb_axios_config)
  // eslint-disable-next-line comma-dangle
  },
  updateParamsList () {
    return {'old': [ 'fq_name'], 'new': [ 'type', 'fq_name', 'next_gpk', 'prior_gpk', 'pos_to_last', 'pos_to_first', 'ext_orgdata_key', 'is_mgr_assignable']}
  },
  update (config, {type_new, fq_name_old, fq_name_new, next_gpk_new, prior_gpk_new, pos_to_last_new, pos_to_first_new, ext_orgdata_key_new, is_mgr_assignable_new}) {
    const params = { 'new': { 'type': type_new, 'fq_name': fq_name_new, 'next_gpk': next_gpk_new, 'prior_gpk': prior_gpk_new, 'pos_to_last': pos_to_last_new, 'pos_to_first': pos_to_first_new, 'ext_orgdata_key': ext_orgdata_key_new, 'is_mgr_assignable': is_mgr_assignable_new}, 'old': { 'fq_name': fq_name_old}}
    // TODO: Return ta-object instead
    return Axios.post(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/org/unit/update`, params, (config || {}).netdb_axios_config)
  // eslint-disable-next-line comma-dangle
  },
}
